import { isAxiosError } from 'axios'

import { MODALS_ID, QUERY_KEY } from '../constants'
import type { components } from '../constants/schema'

import { requestIdentify } from '../utils/identityVerification'
import { queryClient } from '../utils/queryClient'

import { modalStore } from '../provider/ModalProvider'

import { useAlert } from '../hooks'

import { Text } from '../components/text'
import { AlreadyVerificationModal, MismatchUserModal, SuccessVerificationModal } from '../pages/settings/modal'
import type { IdentifyInfo } from '../pages/settings/modal/AlreadyVerificationModal'

/**
 * 본인인증 후 처리
 * @param data ReqQueryIdentification
 * @param redirectUrl string
 * @returns void
 */
export async function handleIdentify(data: components['schemas']['ReqQueryIdentification'], redirectUrl?: string) {
  const openAlert = useAlert()

  try {
    await requestIdentify(data)

    await queryClient.invalidateQueries({ queryKey: [QUERY_KEY.userInfo] })
    await queryClient.invalidateQueries({ queryKey: [QUERY_KEY.product] })

    modalStore.openModal({
      id: MODALS_ID.SUCCESS_VERIFICATION,
      Component: () => <SuccessVerificationModal redirectUrl={redirectUrl} />,
    })
  } catch (error) {
    console.log({ error }, isAxiosError(error))
    if (isAxiosError(error)) {
      const code = error.response?.data.CODE

      switch (code) {
        // 이미 인증한 유저
        case 'IDNTY_050005': {
          const info: IdentifyInfo = error.response?.data?.info
          if (!info) return
          modalStore.openModal({
            id: MODALS_ID.ALREADY_VERIFICATION,
            Component: () => <AlreadyVerificationModal info={info} />,
          })
          return
        }
        // 휴대폰이 본인 명의가 아닌 것
        case 'IDNTY_050006': {
          modalStore.openModal({ id: MODALS_ID.MISMATCH_USER, Component: MismatchUserModal })
          return
        }
        // Yes24에서 제공받은 이름과 본인인증에서의 이름이 다름
        case 'IDNTY_050007': {
          openAlert({
            content: (
              <Text size={16} weight={500} lineHeight={24} $textAlign="center">
                로그인 시 제공받은 명의와 일치하지 않아요
              </Text>
            ),
          })
          return
        }
        // 만 19세 미만일 경우
        case 'IDNTY_050008': {
          openAlert({
            content: (
              <Text size={16} weight={500} lineHeight={24} $textAlign="center">
                만19세 이상부터 본인인증이 가능해요.
                <br />
                자세한 내용은 FAQ를 참고해주세요.
              </Text>
            ),
          })
          return
        }
        default: {
          openAlert({
            content: (
              <Text size={16} weight={500} lineHeight={24} $textAlign="center">
                알 수 없는 이유로 본인인증에 실패했어요.
                <br />
                문제가 계속될 경우 1:1 문의를 통해 문의해 주세요.
              </Text>
            ),
          })
          return
        }
      }
    }
  } finally {
    localStorage.removeItem('isVerification')
  }
}
